export enum Screen {
  register = 'register',
  confirmation = 'confirmation',
  success = 'success',
}
